import { render, staticRenderFns } from "./ResidentialBlockOfApartments.vue?vue&type=template&id=1fbb51ad&scoped=true&"
import script from "./ResidentialBlockOfApartments.vue?vue&type=script&lang=ts&"
export * from "./ResidentialBlockOfApartments.vue?vue&type=script&lang=ts&"
import style0 from "./ResidentialBlockOfApartments.vue?vue&type=style&index=0&id=1fbb51ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbb51ad",
  null
  
)

export default component.exports